export const CAMPAIGN_ACL_OBJECTS = [
    'Campaign',
    'CampaignNew',
    'CampaignDetail'
];
